'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CHANGE_SOURCE_EXTRA = exports.PAGINATION_DATASOURCE = exports.FETCH_DATASOURCE = exports.REGISTER_DATASOURCE = undefined;
exports.registerDataSource = registerDataSource;
exports.fetchDataSource = fetchDataSource;
exports.changePageParams = changePageParams;
exports.changeSourceExtra = changeSourceExtra;

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _fileSaver = require('file-saver');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by sidchik on 05.04.17.
 */

var REGISTER_DATASOURCE = exports.REGISTER_DATASOURCE = 'REGISTER_DATASOURCE';
var FETCH_DATASOURCE = exports.FETCH_DATASOURCE = 'FETCH_DATASOURCE';
var PAGINATION_DATASOURCE = exports.PAGINATION_DATASOURCE = 'PAGINATION_DATASOURCE';
var CHANGE_SOURCE_EXTRA = exports.CHANGE_SOURCE_EXTRA = 'CHANGE_SOURCE_EXTRA';

function registerDataSource(dataSource, reset) {
    return { type: REGISTER_DATASOURCE, payload: dataSource, reset: reset };
}

function fetchDataSource(dataSource) {
    dataSource.fetch();
    return { type: FETCH_DATASOURCE, payload: null };
}

function changePageParams(dataSource, page, perPage) {
    return { type: PAGINATION_DATASOURCE, payload: {
            dataSource: dataSource,
            page: page,
            perPage: perPage
        } };
}

function changeSourceExtra(dataSource, extra) {
    return { type: PAGINATION_DATASOURCE, payload: extra };
}
//# sourceMappingURL=datasource.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/actions/datasource.js
// module id = 743
// module chunks = 5